module.exports = __webpack_public_path__ + "img/logo-wilms-2.353f2889.svg";